import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './ko.json';
import en from './en.json';
const saved=typeof window!=='undefined'?window.localStorage.getItem('bankpark-language'):null;
i18n.use(initReactI18next).init({resources:{ko:{translation:ko},en:{translation:en}},lng:saved||'ko',fallbackLng:'ko',interpolation:{escapeValue:false},react:{useSuspense:false}});
export default i18n;
